import { createLabeledMessages } from '../../../messageUtils';
const special = {
    char_zero: 'znak',
    char_few: 'znaky',
    char_other: 'znakov',
    file_zero: 'súborov',
    file_one: 'súbor',
    file_few: 'súbory',
    file_other: 'súborov'
};
const common = {
    yes: 'ano',
    no: 'nie',
    unknown: 'neznáme',
    choose: 'vybrať',
    close: 'zatvoriť',
    name: 'názov',
    note: 'poznámka',
    from: 'od',
    to: 'do',
    pageSize: 'zobrazené',
    loading: 'Načítavanie',
    back: 'Spät',
    ok: 'Ok',
    loadingApplication: 'Načítanie aplikácie'
};
const auth = {
    accessDenied: 'K tejto zložke nemáte prístup'
};
const generic = {
    noRecord: 'Žiadny záznam',
    noRecordFound: 'Nebol nájdený žiadny záznam',
    configuratorError: 'Stránku se nepodarilo načítať. Zopakujte akciu ešte raz.',
    configuratorLoading: 'Načítavanie, prosím počkajte.',
    delegationNoAccessLogin: 'Do této aplikácie nemáte prístup {{login}}.',
    delegationNoAccessRedirect: 'Budete presmerovaní na zoznam skratiek.',
    noAccess: 'Nemáte prístupové práva do aplikáce.',
    update: 'Opakovať',
    errorDetailLabel: 'Výpis chyby',
    instructionLabel: 'Ak sa chyba vyskytuje opakovane, vytvorte helpdesk a priložte zoznam chýb. Kód skopírujte sem.',
    searchEllipsis: 'Vyhľadať...',
    search: 'Hľadať',
    copied: 'Zkopírované',
    provideDetailsInReport: 'Pri nahlasovaní chyby, napr. prostredníctvom HelpDesku, uveďte podrobnosti.',
    retry: 'Zkúsiť znovu',
    error: 'Chyba',
    closeAll: 'Zavrieť všetko',
    application: 'Aplikácia',
    user: 'Užívateľ',
    logout: 'Odhlásiť sa',
    darkMode: 'Tmavý režim',
    delete: 'Zmazať',
    uploadFile: 'Nahrať súbor',
    minCharacterCount: 'Zadejte aspoň {{count}} znaky',
    loadingData: 'Načítavam údaje',
    missingStateParameter: 'Chýba povinný vstupný parameter'
};
const dropZone = {
    infoText: 'Možnosť nahrať <strong>{{extensions, list}}</strong>. Maximálna veľkosť súboru je <strong>{{size, number(style: unit; unit: megabyte)}}</strong>. ',
    totalAcceptSize: 'Celkovo možnosť nahrať <strong>{{size, number(style: unit; unit: megabyte)}}</strong>.',
    chipWithSize: '{{name}} ({{size, number(style: unit; unit: megabyte)}})',
    choseFileDesktop: 'vyberte súbor',
    choseFileMobile: 'Vybrať súbor',
    dragFile: 'Potiahnite súbor sem alebo',
    wrongFormat: 'Tento formát bohužiaľ nepodporujeme.'
};
const mimeTypes = {
    //audio,application,image,text,video,font
    'mime-audio': 'audio súbory',
    'mime-application': 'aplikačné súbory',
    'mime-image': 'obrázky',
    'mime-text': 'textové súbory',
    'mime-video': 'video súbory',
    'mime-font': 'fonty'
};
const externalLink = {
    externalLinkLoading: 'Načítavanie odkazu, počkajte, prosím.',
    externalLinkError: 'Pri načítaní prepojenia sa vyskytla chyba.'
};
const messages = Object.assign({}, special, common, auth, generic, dropZone, mimeTypes, externalLink);
export default Object.assign({}, messages, createLabeledMessages(messages));
